import axios from "axios";

/**
 * Backend base URL.
 * - If `REACT_APP_BACKEND_URL` matches the current page's origin (or is unset), we
 *   use the relative `/api` path so the same build works on preview, the original
 *   *.emergent.host URL, and the custom production domain without rebuilding.
 * - Otherwise (cross-origin dev), we honour the env var as before.
 */
function resolveBaseUrl() {
  const envUrl = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
  if (typeof window === "undefined") return `${envUrl}/api`;
  const currentOrigin = window.location.origin;
  if (!envUrl || envUrl === currentOrigin) return "/api";
  // If env URL is set but the user is browsing a different origin (e.g. the
  // custom production domain), prefer the current origin — the platform routes
  // /api on every hostname it serves the frontend from.
  try {
    const envHost = new URL(envUrl).host;
    if (envHost !== window.location.host) return "/api";
  } catch (_e) {
    // Malformed env URL — safest fallback is the relative /api path. Logged at
    // info level so deployment misconfigurations are still discoverable.
    if (typeof console !== "undefined" && process.env.NODE_ENV !== "production") {
      if (process.env.NODE_ENV !== "production") console.info("REACT_APP_BACKEND_URL is not a valid URL — using relative /api");
    }
    return "/api";
  }
  return `${envUrl}/api`;
}

export const API = resolveBaseUrl();

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof detail === "object" && detail.msg) return detail.msg;
  return JSON.stringify(detail);
}
